import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAlert,_vm._b({attrs:{"type":"warning","icon":false}},'v-alert',_vm.$attrs,false),[_c('p',{staticClass:"mb-0"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }